import type { TFeatureFlags } from '@roko/ui/types/common'

export const baseFeatures: TFeatureFlags = {
  feature1: {
    enabled: true,
  },
}
